import React from 'react';
import BSEPinone from './BSEPinone';
import BSEContent from './BSEContent';
import BSEPintwo from './BSEPintwo';
import {
  Container,
  SubTitle,
  SubIcon,
  BodyContent,
  TextButton
} from './bseStyle';
import IconPushpin from '../../../../../../../../assets/icons/IconPushpin.svg';
import IconCalendar from '../../../../../../../../assets/icons/IconCalendar.svg';
import IconClock from '../../../../../../../../assets/icons/IconClock.svg';
import { HeaderInfo } from '@/presentation/reusables/Wrapper/styled';
import BSEFooter from './BSEFooter';

interface BSEComponentProps {
  propProcedure: any;
  handleRequestProcedure: () => void;
  handlerRedirectNewPage: any;
}

const BSEComponent = (props: BSEComponentProps) => {
  const { propProcedure, handleRequestProcedure, handlerRedirectNewPage } =
    props;
  return (
    <Container>
      <div>
        <SubTitle>
          <HeaderInfo>
            <SubIcon>
              <img className="PR" src={IconPushpin} alt="IconPushpin" />
              <p>
                Costo: <b>S/ {propProcedure.amount}.00</b>
              </p>
            </SubIcon>
            <SubIcon>
              <img className="PR" src={IconClock} alt="IconClock" />
              <p>{propProcedure.duration}</p>
            </SubIcon>
            <SubIcon>
              <img className="PR" src={IconCalendar} alt="IconCalendar" />
              <p>Fecha límite: {propProcedure.endDate?.toLowerCase()}</p>
            </SubIcon>
          </HeaderInfo>
        </SubTitle>
      </div>
      <BodyContent>
        <BSEPinone
          PropPinOne={propProcedure.pin2}
          paddingTopBoddyTitle="20px"
          marginBodyTitle="20px 16px 8px 16px"
        />
        <BSEContent
          marginBodyContent2="20px 16px 8px 16px"
          handlerRedirectNewPage={handlerRedirectNewPage}
        />
        <BSEPintwo
          PropPinTwo={propProcedure.pin1}
          marginIconArrow="10px 16px 10px 16px"
        />
      </BodyContent>

      <BodyContent>
        <div style={{ padding: 16 }}>
          <BSEFooter />
        </div>
      </BodyContent>
      <TextButton type="button" onClick={handleRequestProcedure}>
        Empezar solicitud
      </TextButton>
    </Container>
  );
};
export default BSEComponent;
